import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import FactDashboardPage from './views/FactDashboard';

export const traceRoutes = [
  {
    path: 'trace',
    name: '数据分析',
    icon: 'lineChart',
    children: [
      {
        index: true,
        element: <Navigate to="fact-dashboard" replace />,
      },
      {
        path: 'fact-dashboard',
        name: '经营分析',
        icon: 'lineChart',
        element: <FactDashboardPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
